import React, { useState } from 'react';
import { CopyClipboardIcon, InfoIcon } from '../../../components/common/SvgIcon';

const AllShortCodes = ({ shortcodes, copyShortcode, loading }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {loading ? (
        <div className="space-y-4">
          <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-8 bg-gray-200 rounded animate-pulse"></div>
        </div>
      ) : (
        <>
          {/* Collapsible Header */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between group transition-all cursor-pointer px-2 sm:px-0"
          >
            <div className="flex items-center gap-2 sm:gap-3">
              {/* Link Icon */}
              <span className="text-xl sm:text-2xl">🔗</span>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-[#17171C]">
                Available Shortcodes
              </h3>
            </div>
            {/* Chevron Icon */}
            <svg
              className={`w-5 h-5 sm:w-6 sm:h-6 text-gray-600 transition-transform duration-300 flex-shrink-0 ${
                isOpen ? 'rotate-180' : ''
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {/* Expandable Content with Smooth Animation */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              isOpen ? 'max-h-[800px] opacity-100 mt-3 sm:mt-4' : 'max-h-0 opacity-0'
            }`}
          >
            <div className="bg-white">
              <div className="bg-gradient-to-r from-purple-50 to-blue-50 border-l-4 border-[#7C3BED] px-4 py-3 mb-4 sm:mb-6 rounded-r-lg">
                <p className="text-sm sm:text-base text-[#17171C] font-medium flex items-center gap-2">
                {InfoIcon}
                  Click on any shortcode below to copy it
                </p>
              </div>
              
              <div className="space-y-2 sm:space-y-3 max-h-[400px] sm:max-h-[500px] md:max-h-[600px] overflow-y-auto pr-1 custom-scrollbar">
                {Object.keys(shortcodes).map((key) => (
                  <button
                    key={key}
                    onClick={() => copyShortcode(key)}
                    className="w-full px-3 py-3 sm:px-4 sm:py-3.5 md:px-5 md:py-3 text-left font-mono text-[#7C3BED] bg-[#F4F4F5] bg-opacity-50 rounded-xl sm:rounded-2xl transition-colors flex items-center justify-between group cursor-pointer hover:bg-opacity-70 active:bg-opacity-90"
                  >
                    <span className="text-xs sm:text-sm md:text-xs !bg-[#7C3BED1A] px-1.5 py-1 sm:p-[7px] bg-opacity-10 rounded break-all">
                      [{key}]
                    </span>
                    <CopyClipboardIcon />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AllShortCodes;